import { render, staticRenderFns } from "./BGATextarea.vue?vue&type=template&id=52b3514e&scoped=true&"
import script from "./BGATextarea.vue?vue&type=script&lang=js&"
export * from "./BGATextarea.vue?vue&type=script&lang=js&"
import style0 from "./BGATextarea.vue?vue&type=style&index=0&id=52b3514e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b3514e",
  null
  
)

export default component.exports